__webpack_require__.p = "/mi-assets/mi-static/mi-account-renderer/web-rel-26.6.2-2026-712026/_next/";